<h3 mat-dialog-title class="title-layout">Reassign Active Work </h3>
<div mat-dialog-content>
  <p>To transfer work to your new pitch variant, select a variant with active work from the list below. </p>

  <form [formGroup]="fg_TransferVariant" >

    <mat-label>Variants with Work</mat-label>
    <mat-form-field class="card-dialog">
      <mat-select id="variant" matInput cdkTextareaAutosize formControlName="f_ReassignVariant">
            <mat-option *ngFor="let variant of variantList" [value]="variant">
                {{variant.variant_name}} <span *ngIf="variant.variant_id == baseVariantID">(Base)</span>
            </mat-option>
        </mat-select> 
    </mat-form-field>
    
  </form>
</div>

<div mat-dialog-actions>
  <button  mat-button color="primary" (click)="onSubmit()">Submit</button>
  <button mat-button (click)="onNoClick()">Cancel</button>
</div>
